import { LOADING_UACS, UACS_FAILED, UACS_SUCCESS, RESET_UACS } from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  data: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_UACS:
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        data: [],
      };

    case UACS_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
      };

    case UACS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        data: [].concat(action.payload),
      };

    case RESET_UACS:
      return (state = initialState);

    default:
      return state;
  }
};
